import { ModuleCommandEnum } from "@/types/enums/module-command.enum";
import { TriangleAlertIcon } from "lucide-react";
import { Trans, useTranslation } from "react-i18next";
import tw from "twin.macro";
import StepActionButton from "./step-action-button";
import { SheetsType } from "./types/sheets.type";
import { SheetsEnum } from "./enums/sheets.enum";
import { toast } from "sonner";
import { getNextStepTranslation } from "./utils/get-next-step-translation";
import { getNextStepAction } from "./utils/get-next-step-action";
import { CommandToSend, useSendCommand } from "@/api/areas/mutations";
import { useAreaDataProvider } from "@/routes/area-aggregate/components/area-data-loader";

const SkipActionSheetBody = ({
  areaId,
  skippedCommand,
  pushSheet,
  backFn,
}: {
  areaId: string;
  skippedCommand: ModuleCommandEnum.UP | ModuleCommandEnum.CLOSE;
  pushSheet: (view: SheetsType) => void;
  backFn: () => void;
}) => {
  const { t: translator } = useTranslation();
  const { mutateAsync: sendCommand } = useSendCommand({
    areaId,
  });
  const { applyOptimisticCommand } = useAreaDataProvider();

  return (
    <div css={[tw`flex flex-col gap-4 px-6 pb-6`]}>
      <div css={[tw`flex justify-between border-yellow-200 pt-2`]}>
        <div
          css={[
            tw`flex items-center gap-2 rounded-r-md p-2 bg-[#fff9eb] text-[#5d4e13e0]`,
            tw`border-l-4 border-yellow-300`,
          ]}
        >
          <span tw="self-start">
            <TriangleAlertIcon
              css={[tw`w-6 h-6 text-yellow-500`]}
              strokeWidth={2}
            />
          </span>
          <div css={[tw`flex flex-col gap-2`]}>
            <p css={[tw`text-sm font-normal`]}>
              <Trans
                i18nKey={
                  skippedCommand === ModuleCommandEnum.UP
                    ? "modulesStates.warningSkippingUp"
                    : "modulesStates.warningSkippingClose"
                }
                components={{
                  highlight: <span css={[tw`font-semibold text-yellow-700`]} />,
                }}
              />
            </p>
            <p css={[tw`text-sm font-normal`]}>
              {translator("modulesStates.avoidBreakingEngines")}
            </p>
          </div>
        </div>
      </div>

      <div tw="pt-10  w-full">
        <StepActionButton
          disabled={false}
          actionTranslation={getNextStepTranslation(skippedCommand, translator)}
          onClick={() => {
            try {
              const nextCommand = getNextStepAction(
                skippedCommand
              ) as CommandToSend;
              applyOptimisticCommand(nextCommand);
              sendCommand({ command: nextCommand });
              pushSheet({
                id: SheetsEnum.ACTION_IN_PROGRESS,
                context: {
                  currentAction: getNextStepAction(skippedCommand),
                },
                canGoBack: false,
              });
            } catch (error) {
              toast.error("Erreur lors de la montée");
            }
          }}
        />
        <StepActionButton
          disabled={false}
          actionTranslation={translator("global.cancel")}
          cancelButton={true}
          onClick={backFn}
        />
      </div>
    </div>
  );
};

export default SkipActionSheetBody;
